import e from "./TypesenseSearchResult.vue2.js";
/* empty css                           */
import o from "../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ o(e, [["__scopeId", "data-v-b084f1d5"]]);
export {
  p as default
};
